<template>
  <v-app>
    <v-container fluid>
      <v-row no-gutters>
            <v-col cols="12" md="12" class="login-part d-flex align-center justify-center flex-column">
              <div class="login-wrapper pt-16 pt-sm-0">
                    <v-form>
                      <v-container>
                        <v-row class="flex-column">
                          <v-col>
                          <div class="d-flex justify-center" justify="center">
                            <v-img src="@/assets/tradexc_vertical_logo.png" contain max-width="250" min-width="100"></v-img>
                          </div>
                          </v-col>
                          <v-form
                            ref="log"
                            v-model="valid"
                            lazy-validation
                          >
                            <v-col>
                              <p class="text-truncate" style="text-align: center">Enter your employee pincode</p>
                              <v-text-field
                                light
                                height="50"
                                id="pincode"
                                ref="pincode"
                                v-model="pincode"
                                v-bind:error="errorindex == 0"
                                single-line
                                label="Pin"
                                hint="Enter your pincode"
                                required
                              ></v-text-field>
                            </v-col>
                            <v-col class="d-flex justify-space-between">
                              <v-btn
                                class="text-capitalize"
                                light
                                large
                                block
                                :disabled="pincode.length < 5 "
                                color="primary"
                                @click="submitPin">
                                Submit
                              </v-btn>
                            </v-col>
                          </v-form>
                        </v-row>
                      </v-container>
                    </v-form>
              </div>
            </v-col>
      </v-row>
    </v-container>
    <v-snackbar
      v-model="alert"
      color="blue">
      {{ message }}
      <template v-slot:action="{ attrs }">
        <v-btn
          dark
          text
          v-bind="attrs"
          @click="alert = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'Auth',
  data() {
    return {
      valid: true,
      initvalue: null,
      errorindex: undefined,
      pincode: '',
      newpassword: '',
      newpassword2: '',
      alert: false,
      message: ''
    }
  },
  methods: {
    ...mapActions('PayStatement', ['getPayStatementWithKey']),
    checkPin(){
      if(this.initvalue==undefined || this.initvalue==null){
        this.$router.push({ path: '/login' })
      }
      if(this.pincode!==this.initvalue.employeepin){
        this.errorindex = 0;
        return false;
      }
      this.errorindex = -1;
      return true;
    },
    submitPin(){
      if(this.checkPin()){
        this.$router.push({ name: 'PayStatementDocView', params: this.initvalue })
      }
    },
    changepassword(){
      if(this.checkError() == false) return;
      const change = {
        useremail: this.email,
        temppassword: this.temppassword,
        newpassword: this.newpassword,
      };
      this.changeUserPassword(change);
    },
  },
  computed: {
    ...mapState('Region', ['regions']),
    ...mapState('Township', ['townships']),
    ...mapState('User', ['users']),
  },
  watch: {
    errorMessage() {
      this.message = this.errorMessage;
      this.alert = this.hasAlert;
    },
  },
  async created(){
    let keyid = this.$route.params.id;
    if(keyid==undefined) {this.$router.replace({ path: '/login' })}
    this.initvalue = await this.getPayStatementWithKey(keyid);
  }
}

</script>

<style src="./Auth.scss" lang="scss"/>
